import React, { useState } from 'react';
import { GiCommercialAirplane } from 'react-icons/gi';
import BookNowModal from './BookNowModal';

const Booknow = ({ category }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  return (
    <>
      <button
        className='common-button mt-3 w-full'
        onClick={handleOpen}
      >
        <span className='common-button__icon-wrapper'>
          <GiCommercialAirplane className='common-button__icon-svg' />
          <GiCommercialAirplane className='common-button__icon-svg common-button__icon-svg--copy' />
        </span>
        Book Now
      </button>
      {modalOpen && (
        <BookNowModal
          open={modalOpen}
          onClose={handleClose}
          selectedCategory={category}
        />
      )}
    </>
  );
};

export default Booknow;
